import { Box, useTheme } from "@seneca/senekit";

import DashboardWrapper from "features/common/components/DashboardWrapper";

import { UnsubscribePageNavbar } from "./components/UnsubscribePageNavbar";
import { UnsubscribePageContent } from "./components/UnsubscribePageContents";

import styles from "./UnsubscribePage.module.scss";

export default function AnonymousUnsubscribePage() {
  const theme = useTheme();

  return (
    <>
      <UnsubscribePageNavbar />
      <DashboardWrapper className={styles.wrapper}>
        <Box
          background={theme.foreground}
          padding="xxlarge"
          borderRadius="large"
        >
          <UnsubscribePageContent />
        </Box>
      </DashboardWrapper>
    </>
  );
}
